'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postShowPageTitleNotification = undefined;

var _createPostMessageAction = require('../../../post-message/actions/createPostMessageAction');

var _PostMessageTypes = require('../../../constants/PostMessageTypes');

var postShowPageTitleNotification = exports.postShowPageTitleNotification = (0, _createPostMessageAction.createPostMessageAction)(_PostMessageTypes.SHOW_PAGE_TITLE_NOTIFICATION);